module.exports = __webpack_public_path__ + "img/tz4.d82875b5.png";